export const classes = {
  isVisible: 'is-visible',
  isInvisible: 'is-invisible',
  withBg: 'with-bg',
  isNavBlack: 'is-nav-black',
  isBlack: 'is-black',
  isActive: 'is-active',
  isOpen: 'is-open',
  isHidden: 'is-hidden',
  isIE: 'is-IE',
  isFixed: 'is-fixed',
  isAbsolute: 'is-absolute',
  isSticky: 'is-sticky',
  noOverflow: 'no-overflow',
  isSmall: 'is-small',
  isLowBurger: 'is-low-burger',
  isDarkened: 'is-darkened',
  isMasked: 'is-masked',
  isShrinked: 'is-shrinked',
  defaultCursor: 'default-cursor',
  noScroll: 'no-scroll',
  applyFixed: 'apply-fixed'
};

export const matchMedia = breakpoint => {
  return window.matchMedia(`only screen and (min-width: ${breakpoint}px)`).matches;
};

export const matchMediaMax = breakpoint => {
  return window.matchMedia(`only screen and (max-width: ${breakpoint}px)`).matches;
};

export const DOM = {
  window,
  $window: $(window),
  $document: $(document),
  $hbody: $('html, body')
}

export const isiE = document.documentMode;

export const breakpoints = {
  xs: 480,
  sm: 768,
  md: 992,
  l: 1199
};

export const events = {
  customCursorUpdate: 'customCursorUpdate'
};

export const touchDevice = 'ontouchstart' in window
|| navigator.maxTouchPoints;

export default classes;
